export enum EnvironmentHostName {
  PRD = "portal.pleevi.ai",
  STG = "portal.stg.pleevi.ai",
  SBX = "portal.sbx.pleevi.ai",
  LOCAL = "localhost",
}

export const getEnvironment = (): keyof typeof EnvironmentHostName => {
  const hostname = window.location.hostname;

  if (hostname === EnvironmentHostName.PRD) {
    return "PRD";
  } else if (hostname === EnvironmentHostName.STG) {
    return "STG";
  } else if (hostname === EnvironmentHostName.SBX) {
    return "SBX";
  } else if (
    hostname === EnvironmentHostName.LOCAL ||
    hostname.endsWith("pleevi.localhost")
  ) {
    return "LOCAL";
  } else {
    throw new Error(`Unknown environment: ${hostname}`);
  }
};
